app.filter('money', () => (function(amount) {
    amount = parseFloat(amount).toFixed(0);
    amount = amount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");
    return amount + ',- Kč';
}));
